// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysis_folder--selected{
    background-color: #f9f9f6;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisFolderList.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".FullAnalysis_folder--selected{\n    background-color: #f9f9f6;\n    border: 1px solid #d9d9d9;\n    border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
